import React from 'react';
import { Button, Grid } from '@material-ui/core';
import moment from 'moment';
import { FormLabel } from '@mui/material';

import Box from 'retired/Box';
import Organization from 'entities/organization/model';

const Document = ({
  document,
}: {
  document: { fileUri: string; uploadedAt: Date; title: string };
}) => (
  <Grid container spacing={3}>
    <Grid item sm={12} md={6} lg={8}>
      <div>
        <Button
          size="small"
          onClick={() => {
            window.open(document.fileUri, '_blank');
          }}
        >
          {document.title}
        </Button>
      </div>
      <FormLabel style={{ fontSize: 12, marginTop: 10 }}>
        Uploaded at: {moment(document.uploadedAt).format('YYYY-MM-DD HH:mm')}
      </FormLabel>
    </Grid>
  </Grid>
);

export const OrganizationDocuments = ({ organization }: { organization: Organization }) => {
  const documents = [
    organization.governmentInformationLetter && {
      ...organization.governmentInformationLetter,
      title: 'Government Information Letter',
    },
    organization.letterOfAssociation && {
      ...organization.letterOfAssociation,
      title: 'Letter of Association',
    },
  ].filter(Boolean);
  if (documents.length === 0) {
    return null;
  }
  return (
    <Box style={{ paddingTop: 0, marginBottom: 30 }}>
      <h2>Organization Documents</h2>
      {documents.map((document) => (
        <Document key={document.fileUri} document={document} />
      ))}
    </Box>
  );
};
